import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

// LayoutMenuData.js

const organizationNavItems = [
  {
    id: 'organization',
    title: 'Organization',
    addFolder: false,
    navList: [
      {
        id: 'dhCampaigns-List',
        label: 'Manage',
        icon: 'bx bx-list-check',
        iconActive: 'bx bx-list-check',
        path: '/organization/manage',
      },
    ],
  },
  // {
  //   id: 'brands',
  //   title: 'Brands',
  //   addFolder: true,
  //   navList: [
  //     {
  //       id: 'danube-properties-brands',
  //       label: 'Danube Properties',
  //       icon: 'bx bx-store-alt',
  //       iconActive: 'bx bxs-store-alt',
  //       path: '/organizations/brands/danube-properties/',
  //       dropdownItems: [
  //         {
  //           label: 'Delete',
  //           icon: 'bx bx-trash',
  //           color: 'text-danger',
  //         },
  //         { label: 'Edit', icon: 'bx bx-pencil' },
  //       ],
  //     },
  //     {
  //       id: 'danube-home-brands',
  //       label: 'Danube Home',
  //       icon: 'bx bx-store-alt',
  //       iconActive: 'bx bxs-store-alt',
  //       path: '/organizations/brands/danube-home/',
  //       dropdownItems: [
  //         {
  //           label: 'Delete',
  //           icon: 'bx bx-trash',
  //           color: 'text-danger',
  //         },
  //         { label: 'Edit', icon: 'bx bx-pencil' },
  //       ],
  //     },
  //     {
  //       id: 'milano-brands',
  //       label: 'Milano',
  //       icon: 'bx bx-store-alt',
  //       iconActive: 'bx bxs-store-alt',
  //       path: '/organizations/brands/milano/',
  //       dropdownItems: [
  //         {
  //           label: 'Delete',
  //           icon: 'bx bx-trash',
  //           color: 'text-danger',
  //         },
  //         { label: 'Edit', icon: 'bx bx-pencil' },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: 'Countries',
  //   title: 'Countries',
  //   addFolder: true,
  //   navList: [
  //     {
  //       id: 'United Arab Emirates',
  //       label: 'United Arab Emirates',
  //       icon: 'bx bx-store-alt',
  //       iconActive: 'bx bxs-store-alt',
  //       // path: '/organizations/brands/danube-properties/',
  //       addFolder: true,

  //       dropdownItems: [
  //         {
  //           label: 'Delete',
  //           icon: 'bx bx-trash',
  //           color: 'text-danger',
  //         },
  //         { label: 'Edit', icon: 'bx bx-pencil' },
  //       ],
  //     },
  //     {
  //       id: 'Bahrain',
  //       label: 'Bahrain',
  //       icon: 'bx bx-store-alt',
  //       iconActive: 'bx bxs-store-alt',
  //       path: '/organizations/brands/danube-home/',
  //       dropdownItems: [
  //         {
  //           label: 'Delete',
  //           icon: 'bx bx-trash',
  //           color: 'text-danger',
  //         },
  //         { label: 'Edit', icon: 'bx bx-pencil' },
  //       ],
  //     },
  //     {
  //       id: 'Oman',
  //       label: 'Oman',
  //       icon: 'bx bx-store-alt',
  //       iconActive: 'bx bxs-store-alt',
  //       path: '/organizations/brands/danube-home/',
  //       dropdownItems: [
  //         {
  //           label: 'Delete',
  //           icon: 'bx bx-trash',
  //           color: 'text-danger',
  //         },
  //         { label: 'Edit', icon: 'bx bx-pencil' },
  //       ],
  //     },
  //     {
  //       id: 'Qatar',
  //       label: 'Qatar',
  //       icon: 'bx bx-store-alt',
  //       iconActive: 'bx bxs-store-alt',
  //       path: '/organizations/brands/danube-home/',
  //       dropdownItems: [
  //         {
  //           label: 'Delete',
  //           icon: 'bx bx-trash',
  //           color: 'text-danger',
  //         },
  //         { label: 'Edit', icon: 'bx bx-pencil' },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: 'Users and Permissions',
  //   title: 'Users and Permissions',
  //   navList: [
  //     {
  //       id: 'Admin-Users',
  //       label: 'Admin Users',
  //       icon: 'bx bx-folder',
  //       iconActive: 'bx bxs-folder-open',
  //       path: '#',
  //     },
  //     {
  //       id: 'Roles',
  //       label: 'Roles',
  //       icon: 'bx bx-folder',
  //       iconActive: 'ri-user-settings-fill',
  //       path: '/admin-user/roles',
  //     },
  //   ],
  // },
];

const currencyNavItems = [
  {
    id: 'dhCampaigns',
    title: 'Ahlan',
    addFolder: false,
    navList: [
      {
        id: 'transactions',
        label: 'Transactions ',
        icon: 'bx bx-list-check',
        iconActive: 'bx bx-list-check',
        path: '/currencies/ahlan/transactions',
      },
      {
        id: 'Tier Master',
        label: 'Tier Master ',
        icon: 'bx bx-list-check',
        iconActive: 'bx bx-list-check',
        path: '/currencies/alhan/tire-master',
      },
      {
        id: 'Currency Configurations',
        label: 'Currency Configurations ',
        icon: 'bx bx-list-check',
        iconActive: 'bx bx-list-check',
        path: '/reward-types/detail/alhan/basic',
      },
    ],
  },
];

const membersNavItems = [
  {
    id: 'members',
    title: 'Members Dashboard',
    addFolder: false,
    navList: [
      {
        id: 'members',
        label: 'Members List ',
        icon: 'bx bx-list-check',
        iconActive: 'bx bx-list-check',
        path: '/members/list',
      },
    ],
  },
  {
    id: 'views',
    title: 'Views',
    navList: [
      {
        id: 'Exported-Requests',
        label: 'Exported Requests',
        icon: 'ri-file-3-line',
        iconActive: 'ri-file-text-line',
        path: '/exported-requests',
      },

      {
        id: 'segments',
        label: 'User Segments',
        icon: 'ri-apps-line',
        iconActive: 'ri-apps-fill',
        path: '/segments',
      },
    ],
  },
  {
    id: 'Configurations',
    title: 'Configurations',
    addFolder: false,
    navList: [
      {
        id: 'schema',
        label: 'Member Standard Attribute',
        path: '/members/configurations/general/members',
        icon: 'bx bx-cabinet',
        iconActive: 'bx bx-cabinet',
      },
      {
        id: 'members-localization',
        label: 'Localization Attributes',
        path: '/members/configurations/general/members-localization',
        icon: 'bx bx-cabinet',
        iconActive: 'bx bx-cabinet',
      },
      {
        id: 'members-lifecycle',
        label: 'Lifecycle Attributes',
        path: '/members/configurations/general/members-lifecycle',
        icon: 'bx bx-cabinet',
        iconActive: 'bx bx-cabinet',
      },
    ],
  },
  {
    id: 'Trackers',
    title: 'Trackers',
    addFolder: false,
    navList: [
      {
        id: 'schema',
        label: 'Trackers',
        path: '/members/trackers/list',
        icon: 'bx bx-cabinet',
        iconActive: 'bx bx-cabinet',
      },
    ],
  },
];

const getPromotionNavItems = (campaignTypeId) => {
  try {
    if (campaignTypeId) {
      return [
        {
          id: 'dhCampaigns',
          title: 'Danube Home Campaigns',
          addFolder: false,
          navList: [
            {
              id: 'dhCampaigns-List',
              label: 'List ',
              icon: 'bx bx-list-check',
              iconActive: 'bx bx-list-check',
              path: `/promotions/${campaignTypeId}/list`,
            },
            {
              id: 'dhCampaigns-prioritization',
              label: 'Prioritization ',
              icon: 'bx bx-sort-alt-2',
              iconActive: 'bx bx-sort-alt-2',
              path: `/promotions/${campaignTypeId}/prioritization`,
            },
            {
              id: 'dhCampaigns-calendar',
              label: 'Calendar ',
              icon: 'bx bx-calendar',
              iconActive: 'bx bx-calendar',
              path: `/promotions/${campaignTypeId}/calendar`,
            },
          ],
        },
        {
          id: 'redemptions',
          title: 'Redemptions',
          addFolder: false,
          navList: [
            {
              id: 'redemptions-Stream',
              label: 'Stream',
              icon: 'bx bx-list-check',
              iconActive: 'bx bx-list-check',
              path: `/promotions/${campaignTypeId}/redemptions-stream`,
            },
            {
              id: 'dhCampaigns-calendar',
              label: 'Calendar View',
              icon: 'bx bx-calendar',
              iconActive: 'bx bx-calendar',
              path: `/promotions/${campaignTypeId}/calendar`,
            },
          ],
        },
        // {
        //   id: 'analytics',
        //   title: 'DIY Analytics',
        //   addFolder: true,
        //   navList: [
        //     {
        //       isLocked: true,
        //       id: 'Daily Redemption Summary',
        //       label: 'Daily Redemption Summary',
        //       icon: 'bx bx-bookmark',
        //       iconActive: 'bx bx-bookmark',
        //       path: `/analytics/${campaignTypeId}/daily`,
        //     },
        //     {
        //       isLocked: true,
        //       id: 'Weekly Report',
        //       label: 'Weekly Report',
        //       icon: 'bx bx-bookmark',
        //       iconActive: 'bx bx-bookmark',
        //       path: '/gift-card/ahlan-gift-card/',
        //       dropdownItems: [
        //         {
        //           label: 'Delete',
        //           icon: 'bx bx-trash',
        //           color: 'text-danger',
        //         },
        //         { label: 'Edit', icon: 'bx bx-pencil' },
        //       ],
        //       subItems: [
        //         {
        //           id: 'gift-cards',
        //           label: 'Gift Cards',
        //           icon1: 'ri-gift-line',
        //           iconActive1: 'ri-gift-fill',
        //           path: '/gift-card/ahlan-gift-card/gift-card-list/',
        //           dropdownItems: [
        //             { label: 'Change view visibility', icon: 'ri-eye-line' },
        //           ],
        //         },
        //       ],
        //     },
        //     {
        //       isLocked: true,
        //       id: 'Monthly Report',
        //       label: 'Monthly Report',
        //       icon: 'bx bx-bookmark',
        //       iconActive: 'bx bx-bookmark',
        //       path: '/gift-card/ahlan-gift-card/',
        //       dropdownItems: [
        //         {
        //           label: 'Delete',
        //           icon: 'bx bx-trash',
        //           color: 'text-danger',
        //         },
        //         { label: 'Edit', icon: 'bx bx-pencil' },
        //       ],
        //       subItems: [
        //         {
        //           id: 'gift-cards',
        //           label: 'Gift Cards',
        //           icon1: 'ri-gift-line',
        //           iconActive1: 'ri-gift-fill',
        //           path: '/gift-card/ahlan-gift-card/gift-card-list/',
        //           dropdownItems: [
        //             { label: 'Change view visibility', icon: 'ri-eye-line' },
        //           ],
        //         },
        //       ],
        //     },
        //   ],
        // },
        {
          id: 'Configurations',
          title: 'Configurations',
          addFolder: false,
          navList: [
            {
              id: 'fields',
              label: 'Rule Fields',
              path: `/promotions/${campaignTypeId}/configurations/fields`,
              icon: 'bx bx-cabinet',
              iconActive: 'bx bx-cabinet',
            },
            {
              id: 'basic-meta',
              label: 'Basic Details Fields',
              path: `/promotions/${campaignTypeId}/configurations/general/basic-meta`,
              icon: 'bx bx-folder',
              iconActive: 'bx bx-folder',
            },
            {
              id: 'input-meta',
              label: 'Messages Fields',
              path: `/promotions/${campaignTypeId}/configurations/general/input-meta`,
              icon: 'bx bx-font-color',
              iconActive: 'bx bx-font-color',
            },
            {
              id: 'output-meta',
              label: 'Effects Fields',
              path: `/promotions/${campaignTypeId}/configurations/general/output-meta`,
              icon: 'bx bx-outline',
              iconActive: 'bx bx-outline',
            },
            {
              id: 'milestone-schema',
              label: 'Milestone Fields',
              path: `/promotions/${campaignTypeId}/configurations/general/milestone-schema`,
              icon: 'bx bx-git-merge',
              iconActive: 'bx bx-git-merge',
            },
            {
              id: 'languages',
              label: 'Languages',
              path: `/promotions/${campaignTypeId}/configurations/general/languages`,
              icon: 'bx bx-globe',
              iconActive: 'bx bx-globe',
            },
            {
              id: 'general/basket-playground',
              label: 'Basket Playground',
              path: `/promotions/${campaignTypeId}/configurations/general/basket-playground`,
              icon: 'bx bx-play-circle',
              iconActive: 'bx bx-play-circle',
            },
            {
              id: 'teams',
              label: 'Teams',
              path: `/promotions/${campaignTypeId}/configurations/teams`,
              icon: 'bx bx-group',
              iconActive: 'bx bx-group',
            },
          ],
        },
        {
          id: 'views',
          title: 'Views',
          navList: [
            {
              id: 'Exported-Requests',
              label: 'Exported Requests',
              icon: 'ri-file-3-line',
              iconActive: 'ri-file-text-line',
              path: '/exported-requests',
            },
          ],
        },
      ];
    }
    return [];
  } catch (e) {
    console.log(e);
  }
};

const getBrandNavItems = (brands = []) => {
  try {
    const brandNav = {
      id: 'brands',
      title: 'Brands',
      addFolder: false,
      navList: [],
    };

    brands?.map((brand) => {
      const slug = brand?.brandId?.replace('_', '-')?.toLowerCase();
      brandNav?.navList?.push({
        id: `${slug}`,
        label: brand?.name,
        icon: 'bx bx-store-alt',
        iconActive: 'bx bxs-store-alt',
        path: `/brand/${slug}/basic`,
        dropdownItems: [
          {
            label: 'Delete',
            icon: 'bx bx-trash',
            color: 'text-danger',
          },
          { label: 'Edit', icon: 'bx bx-pencil' },
        ],
      });
    });
    return brandNav;
  } catch (e) {
    console.log(e);
  }
};

const getCountryNavItems = (countries) => {
  try {
    const countryNav = {
      id: 'countries',
      title: 'Countries',
      addFolder: false,
      navList: [],
    };

    countries?.map((country) => {
      countryNav?.navList?.push({
        id: `${country?.name}`,
        label: country?.name,
        icon: null,
        iconActive: null,
        path: `/organization/country/${country?.countryCode}/`,
        addFolder: false,
        flag: country?.flag,
        dropdownItems: [
          {
            label: 'Delete',
            icon: 'bx bx-trash',
            color: 'text-danger',
          },
          { label: 'Edit', icon: 'bx bx-pencil' },
        ],
      });
    });

    return countryNav;
  } catch (e) {
    console.log(e);
  }
};

const getAnalyticsNavItems = (campaignTypeId, analyticsPages) => {
  try {
    const analyticsNav = {
      id: 'analytics',
      title: 'DIY Analytics',
      addFolder: true,
      navList: [],
    };

    analyticsPages?.map((page) => {
      analyticsNav?.navList?.push({
        id: `${page?.name}`,
        label: page?.name,
        icon: null,
        iconActive: null,
        path: `/promotions/${campaignTypeId}/analytics/${page?.pageId}`,
        addFolder: false,
      });
    });

    return analyticsNav;
  } catch (e) {
    console.log(e);
  }
};

export const useNavItems = () => {
  const location = useLocation();
  const { organizationTree, countries, campaignTypes } = useSelector(
    (state) => state?.organization
  );

  const { analyticsPages } = useSelector((state) => state?.analytics);

  const { brands } = organizationTree;
  const { campaignTypeId } = useParams();

  const latestCampaignType =
    campaignTypes?.find((type) => {
      return (
        type?.campaignTypeId ===
        campaignTypeId?.toUpperCase()?.replaceAll('-', '_')
      );
    }) || campaignTypes?.[0];

  const navItems = useMemo(() => {
    if (location.pathname.startsWith('/promotions')) {
      const promoNav = getPromotionNavItems(
        latestCampaignType?.campaignTypeId?.toLowerCase()?.replaceAll('_', '-')
      );

      let analyticsNav = null;
      // if (analyticsPages?.length > 0) {
      analyticsNav = getAnalyticsNavItems(
        latestCampaignType?.campaignTypeId?.toLowerCase()?.replaceAll('_', '-'),
        analyticsPages
      );
      // }

      if (analyticsNav) {
        return [...promoNav.slice(0, 2), analyticsNav, ...promoNav.slice(2)];
      }
      return [...promoNav];
    } else if (
      location.pathname.startsWith('/currencies') ||
      location.pathname.startsWith('/reward-types')
    ) {
      return currencyNavItems;
    } else if (
      location.pathname.startsWith('/organization') ||
      location.pathname.startsWith('/brand')
    ) {
      const brandNav = getBrandNavItems(brands);
      const countryNav = getCountryNavItems(countries);
      return [...organizationNavItems, brandNav, countryNav];
    } else if (location.pathname.startsWith('/members')) {
      return membersNavItems;
    } else {
      const promoNav = getPromotionNavItems(
        latestCampaignType?.campaignTypeId?.toLowerCase()?.replaceAll('_', '-')
      );

      let analyticsNav = null;
      analyticsNav = getAnalyticsNavItems(
        latestCampaignType?.campaignTypeId?.toLowerCase()?.replaceAll('_', '-'),
        analyticsPages
      );

      if (analyticsNav) {
        return [...promoNav.slice(0, 2), analyticsNav, ...promoNav.slice(2)];
      }
      return [...promoNav];
    }
  }, [
    location.pathname,
    countries,
    organizationTree,
    campaignTypes,
    campaignTypeId,
    analyticsPages,
  ]);

  return navItems;
};
